import { render } from "./OfficialLogin.vue?vue&type=template&id=c655ee0c&scoped=true"
import script from "./OfficialLogin.vue?vue&type=script&lang=js"
export * from "./OfficialLogin.vue?vue&type=script&lang=js"

import "./OfficialLogin.vue?vue&type=style&index=0&id=c655ee0c&scoped=true&lang=less"

import exportComponent from "E:\\Code\\TECS\\TECS-FE-ENDUSER-NEW\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c655ee0c"]])

export default __exports__